module.exports = __webpack_public_path__ + "static/media/T12-Babel.c4759c01.svg";